import "./pageloader.css";

const PageLoader = () => {
  return (
    <div className="page-loader">
      <div className="loader-container">
        <div className="waveform-container">
          <div className="wave-bar wave-bar-1">
            <span className="flower">🌼</span>
            <div className="white-dot"></div>
          </div>
          <div className="wave-bar wave-bar-2">
            <span className="flower">🌻</span>
            <div className="white-dot"></div>
          </div>
          <div className="wave-bar wave-bar-3">
            <span className="flower">🌼</span>
            <div className="white-dot"></div>
          </div>
          <div className="wave-bar wave-bar-4">
            <span className="flower">🌻</span>
            <div className="white-dot"></div>
          </div>
          <div className="wave-bar wave-bar-5">
            <span className="flower">🌼</span>
            <div className="white-dot"></div>
          </div>
          <div className="wave-bar wave-bar-6">
            <span className="flower">🌻</span>
            <div className="white-dot"></div>
          </div>
          <div className="wave-bar wave-bar-7">
            <span className="flower">🌼</span>
            <div className="white-dot"></div>
          </div>
          <div className="wave-bar wave-bar-8">
            <span className="flower">🌻</span>
            <div className="white-dot"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageLoader;
